// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:640px){.desktop[data-v-c25895ae]{display:none}.mobile[data-v-c25895ae]{display:block}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
